<ng-container *transloco="let t; read: 'qqc'">
  <form
    [formGroup]="qqcForm"
    quote="qqcForm"
    [model]="'input'"
    (ngSubmit)="onSubmit()"
    (keydown.enter)="$event.preventDefault()"
    [attr.data-e2e]="e2eId.Form"
  >
    <h2 class="qqc-title">{{ t(titleTranslation) }}</h2>

    <nibtravel-qqc-alert *ngIf="!isEditMode"></nibtravel-qqc-alert>

    <ng-container *ngIf="!isEditMode">
      <nibtravel-trip-selector
        *featureToggle="QqcTripTypeId"
      ></nibtravel-trip-selector>
    </ng-container>

    <div class="qqc-middle-col">
      <ng-container *ngIf="isEditMode; else defaultDestinationField">
        <nibtravel-qqc-destination
          [qqcForm]="qqcForm"
          *featureToggle="QqcDestinationId"
          [previousQuoteDestinations]="previousQuoteDestinations"
          [currentRoute]="currentRoute"
          [previousQuoteDestinations]="previousQuoteDestinations"
          focus
        ></nibtravel-qqc-destination>
      </ng-container>
      <nibtravel-qqc-travel-dates
        [qqcForm]="qqcForm"
        *featureToggle="QqcTravelDatesId"
      ></nibtravel-qqc-travel-dates>
      <ng-template #defaultDestinationField>
        <nibtravel-qqc-destination
          [qqcForm]="qqcForm"
          *featureToggle="QqcDestinationId"
        ></nibtravel-qqc-destination>
      </ng-template>
    </div>

    <div class="qqc-last-col">
      <nibtravel-qqc-age-input
        [qqcForm]="qqcForm"
        *featureToggle="QqcTravellersAgeId"
      ></nibtravel-qqc-age-input>
      <span class="button-inline qqc-button-cta">
        <nibtravel-button
          id="qqc-get-quote"
          name="qqc-get-quote"
          [e2eId]="e2eId.GetQuote"
          [text]="t(btnQuoteTranslation)"
          [disabled]="showAustraliaAlert"
          [type]="'primary'"
          [size]="'lg'"
          [loader]="requesting$ | async"
        ></nibtravel-button>

        <nibtravel-button
          [text]="'Cancel'"
          [e2eId]="e2eId.CancelQuote"
          [type]="'ghost'"
          (btnClick)="closeSidebar($event, 'cancel')"
          *ngIf="isEditMode"
        ></nibtravel-button>
      </span>
    </div>

    <nibtravel-pmi-option
      class="input-group"
      [isQqc]="true"
      *featureToggle="QqcPrivateInsuranceId"
    ></nibtravel-pmi-option>

    <nibtravel-modal
      [modalId]="modalId"
      [closeButtonText]="'Close'"
      [headerTitle]="t('age-ambiguity.modal-title')"
      [customFooter]="true"
      *ngIf="showAmbiguity$ | async as showAmbiguity"
      ><nibtravel-age-ambiguity *ngIf="showAmbiguity">
      </nibtravel-age-ambiguity>

      <ng-container footer>
        <nibtravel-button
          [text]="t('age-ambiguity.btn-confirm')"
          [type]="'primary'"
          (btnClick)="onAmbiguityConfirm()"
        ></nibtravel-button>
        <nibtravel-link-icon
          [icon]="icon.Close"
          [iconPosition]="position.Start"
          spacing="space-sides"
          [linkText]="t('age-ambiguity.btn-cancel')"
          (click)="closeModal()"
        ></nibtravel-link-icon>
      </ng-container>
    </nibtravel-modal>

    <nibtravel-modal
      [modalId]="domesticInternationalAlertModalId"
      [closeButtonText]="'Close'"
      [headerTitle]="
        fromDomesticToInternational
          ? t('domestic-switch-to-international.title')
          : t('international-switch-to-domestic.title')
      "
      [customFooter]="true"
      *ngIf="showDomesticInternationalAlert$ | async"
      ><nibtravel-domestic-international-alert
        [alertText]="
          fromDomesticToInternational
            ? t('domestic-switch-to-international.bodyContent')
            : t('international-switch-to-domestic.bodyContent')
        "
      >
      </nibtravel-domestic-international-alert>

      <ng-container footer>
        <nibtravel-button
          [text]="
            fromDomesticToInternational
              ? t('domestic-switch-to-international.YesButton')
              : t('international-switch-to-domestic.YesButton')
          "
          [type]="'primary'"
          (btnClick)="onChangeDestinationConfirm()"
        ></nibtravel-button>
        <nibtravel-link-icon
          [icon]="icon.Close"
          [iconPosition]="position.Start"
          spacing="space-sides"
          [linkText]="
            fromDomesticToInternational
              ? t('domestic-switch-to-international.NoButton')
              : t('international-switch-to-domestic.NoButton')
          "
          (click)="onCloseChangeDestinationAlertModal(true)"
        ></nibtravel-link-icon>
      </ng-container>
    </nibtravel-modal>
    <span class="qqc-tmd paragraph" *ngIf="isStandalone">
      Consider the
      <a target="_blank" href="/policy-hub">Product Disclosure Statement</a> and
      <a target="_blank" href="/policy-hub">Target Market Determination</a> and
      whether TID is right for you.
    </span>
  </form>
</ng-container>
